interface PersonName {
  firstName?: string;
  lastName?: string;
  middleName?: string;
  suffix?: string;
}

interface PersonContactInfo {
  emailAddress?: string;
  homePhoneNumber?: string;
  mobilePhoneNumber?: string;
}

export interface VerifiedPatient {
  name?: PersonName;
  preferredSex?: string;
  contactInfo?: PersonContactInfo;
}

///////////////////////////////////////////////
// defaults for testing
export const DefaultTestPersonName: PersonName = {
  firstName: 'fName',
  lastName: 'lName',
  middleName: 'mName',
  suffix: 'suffix',
};

export const DefaultTestPersonContactInfo: PersonContactInfo = {
  emailAddress: 'somePatient@patientEmail.com',
  homePhoneNumber: '7155555555',
  mobilePhoneNumber: '7155555555',
};

export const DefaultTestVerifiedPatient: VerifiedPatient = {
  name: DefaultTestPersonName,
  preferredSex: 'Female',
  contactInfo: DefaultTestPersonContactInfo,
};
